import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  padding: 0 0 188px 0;
  @media (min-width: 992px) {
    padding: 0 0 0 0;
  }
  .HeroImage_imageWrapper {
    background-size: cover;
    background-position: center center;
    width: 100%;
    padding: 56.25% 0 0 0;
    position: relative;
    @media (min-width: 992px) {
      padding: 0;
      height: 70vh;
    }
    &:after {
      content: '';
      position: absolute;
      display: block;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      background-color: rgba(0,0,0,.1);
    }
  }
  .HeroImage_headlineWrapper {
    position: absolute;
    width: 100%;
    padding: 30px 0 40px 0;
    text-align: center;
    background-color: #FFFFFF;
    z-index: 2;
    @media (min-width: 992px) {
      background-color: transparent;
      bottom: 100px;
      padding: 0;
    }
  }
  .HeroImage_headline {
    text-align: center;
    font-family: ${typography.Serif};
    color: ${colors.color1};
    text-transform: uppercase;
    font-weight: 700;
    font-size: 36px;
    line-height: 1;
    margin: 0 0 15px 0;
    letter-spacing: 1px;
    @media (min-width: 992px) {
      font-size: 110px;
      color: #FFFFFF;
      text-shadow: 0 4px 2px rgba(0,0,0,0.50);
      margin-bottom:40px;
      line-height: 1;
      padding:0 40px;
    }
  }
  .HeroImage_preHeadline {
    font-weight: 300;
    font-size: 26px;
    @media (min-width: 992px) {
      font-size: 46px;
      font-weight: 400;
    }
  }
  .HeroImage_headlineButton {
    background-color: ${colors.color2};
    letter-spacing: 2px;
    font-size: 18px;
    line-height: 1;
    text-transform: uppercase;
    padding: 15px 45px;
    color:white;
    @media (min-width: 992px) {
      border: 2px solid ${colors.color2Lightest};
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      padding: 15px 50px;
    }
  }
`;

class HeroImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerImage: undefined,
    };
  }

  componentDidMount() {
    this.getHeaderImage();
  }

  getHeaderImage() {
    let { headerImage } = this.state;

    if (!headerImage) {
      headerImage = _.sample(_.get(this.props.page, 'header_images'));

      this.setState({
        headerImage: buildThumbnailUrl(_.get(headerImage, 'contentUrl'), { width: 2000, height: 2000 }),
      });
    }
  }

  render() {
    const { headerImage } = this.state;
    return (
      <div className={styles}>
        <div
          className="HeroImage_imageWrapper"
          style={{ backgroundImage: `url('${headerImage}')` }}
        >
          <div className="HeroImage_headlineWrapper">
            <h2 className="HeroImage_headline">
              Building Dreams<br />
              <span className="HeroImage_preHeadline">One Home At A Time</span>
            </h2>
            {/*
              <Link name="plans" className="btn HeroImage_headlineButton">See Our Homes</Link>
            */}
          </div>
        </div>
      </div>
    );
  }
}

HeroImage.propTypes = {
  page: PropTypes.object.isRequired,
};

export default HeroImage;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroImage.js